const getErrorMessage = (err) => {
  switch (err.code) {
    case "ERR_NETWORK":
      return "Le serveur est inaccessible. Vérifiez votre connexion réseau puis réessayez.";
    default:
      if (err.response && err.response.status) {
        if (err.response.status == 500) {
          return "Erreur sur le serveur. Merci d'en informer l'équipe d'Europharmat.";
        } else if (err.response.status == 400) {
          if (err.response.data) {
            if (err.response.data.error) {
              return err.response.data.error;
            } else if (err.response.data) {
              const errors = Object.values(err.response.data.errors).flatMap(
                (item) => item
              );
              return errors || "L'objet envoyé par la requête ne convient pas.";
            }
          } else {
            return "L'objet envoyé par la requête ne convient pas.";
          }
        } else if (err.response.status == 404) {
          return "La ressource que vous recherchez n'a pas pu être trouvée.";
        } else if (err.response.status == 403) {
          return "La ressource que vous recherchez est interdite.";
        }
      } else if (err.message && err.message != "") {
        return err.message;
      }
      return "Une erreur inconnue s'est produite.";
  }
};

export default {
  state: {
    visible: false,
    message: null,
    error: null,
  },
  getters: {},
  mutations: {
    SET_VISIBLE(state, payload) {
      state.visible = payload;
    },
    SET_MESSAGE(state, payload) {
      state.message = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
  },
  actions: {
    displayError({ commit }) {
      commit("SET_VISIBLE", true);
    },
    hideError({ commit }) {
      commit("SET_VISIBLE", false);
      commit("SET_MESSAGE", null);
      commit("SET_ERROR", null);
    },
    setMessage({ commit, dispatch }, message) {
      commit("SET_MESSAGE", message);
      dispatch("displayError");
    },
    setErreur({ commit, dispatch }, payload) {
      commit("SET_ERROR", payload);
      let message = getErrorMessage(payload);
      dispatch("setMessage", message);
    },
  },
};
